import quotes from 'data/quotes.json';

// Exact ACA Benchmark Table for Single, Couple, and Family (Non-Tobacco and Tobacco)
export const ACA_BENCHMARK_TABLE = {
  18: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  19: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  20: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  21: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  22: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  23: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  24: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  25: { singleNT: 415, singleT: 477, coupleNT: 830, coupleT: 955, familyNT: 1230, familyT: 1415 },
  26: { singleNT: 438, singleT: 504, coupleNT: 876, coupleT: 1007, familyNT: 1276, familyT: 1467 },
  27: { singleNT: 461, singleT: 530, coupleNT: 922, coupleT: 1060, familyNT: 1322, familyT: 1520 },
  28: { singleNT: 484, singleT: 557, coupleNT: 968, coupleT: 1113, familyNT: 1368, familyT: 1573 },
  29: { singleNT: 507, singleT: 583, coupleNT: 1014, coupleT: 1166, familyNT: 1414, familyT: 1626 },
  30: { singleNT: 530, singleT: 610, coupleNT: 1060, coupleT: 1219, familyNT: 1460, familyT: 1679 },
  31: { singleNT: 544, singleT: 626, coupleNT: 1088, coupleT: 1251, familyNT: 1488, familyT: 1711 },
  32: { singleNT: 558, singleT: 642, coupleNT: 1116, coupleT: 1283, familyNT: 1516, familyT: 1743 },
  33: { singleNT: 572, singleT: 658, coupleNT: 1144, coupleT: 1316, familyNT: 1544, familyT: 1776 },
  34: { singleNT: 586, singleT: 674, coupleNT: 1172, coupleT: 1348, familyNT: 1572, familyT: 1808 },
  35: { singleNT: 600, singleT: 690, coupleNT: 1200, coupleT: 1380, familyNT: 1600, familyT: 1840 },
  36: { singleNT: 610, singleT: 702, coupleNT: 1220, coupleT: 1403, familyNT: 1620, familyT: 1863 },
  37: { singleNT: 620, singleT: 713, coupleNT: 1240, coupleT: 1426, familyNT: 1640, familyT: 1886 },
  38: { singleNT: 630, singleT: 725, coupleNT: 1260, coupleT: 1449, familyNT: 1660, familyT: 1909 },
  39: { singleNT: 640, singleT: 736, coupleNT: 1280, coupleT: 1472, familyNT: 1680, familyT: 1932 },
  40: { singleNT: 650, singleT: 748, coupleNT: 1300, coupleT: 1495, familyNT: 1700, familyT: 1955 },
  41: { singleNT: 670, singleT: 771, coupleNT: 1340, coupleT: 1541, familyNT: 1740, familyT: 2001 },
  42: { singleNT: 690, singleT: 794, coupleNT: 1380, coupleT: 1587, familyNT: 1780, familyT: 2047 },
  43: { singleNT: 710, singleT: 817, coupleNT: 1420, coupleT: 1633, familyNT: 1820, familyT: 2093 },
  44: { singleNT: 730, singleT: 840, coupleNT: 1460, coupleT: 1679, familyNT: 1860, familyT: 2139 },
  45: { singleNT: 750, singleT: 863, coupleNT: 1500, coupleT: 1725, familyNT: 1900, familyT: 2185 },
  46: { singleNT: 780, singleT: 897, coupleNT: 1560, coupleT: 1794, familyNT: 1960, familyT: 2254 },
  47: { singleNT: 810, singleT: 932, coupleNT: 1620, coupleT: 1863, familyNT: 2020, familyT: 2323 },
  48: { singleNT: 840, singleT: 966, coupleNT: 1680, coupleT: 1932, familyNT: 2080, familyT: 2392 },
  49: { singleNT: 870, singleT: 1001, coupleNT: 1740, coupleT: 2001, familyNT: 2140, familyT: 2461 },
  50: { singleNT: 900, singleT: 1035, coupleNT: 1800, coupleT: 2070, familyNT: 2200, familyT: 2530 },
  51: { singleNT: 936, singleT: 1076, coupleNT: 1872, coupleT: 2153, familyNT: 2272, familyT: 2613 },
  52: { singleNT: 972, singleT: 1118, coupleNT: 1944, coupleT: 2236, familyNT: 2344, familyT: 2696 },
  53: { singleNT: 1008, singleT: 1159, coupleNT: 2016, coupleT: 2318, familyNT: 2416, familyT: 2778 },
  54: { singleNT: 1044, singleT: 1201, coupleNT: 2088, coupleT: 2401, familyNT: 2488, familyT: 2861 },
  55: { singleNT: 1080, singleT: 1242, coupleNT: 2160, coupleT: 2484, familyNT: 2560, familyT: 2944 },
  56: { singleNT: 1114, singleT: 1281, coupleNT: 2228, coupleT: 2562, familyNT: 2628, familyT: 3022 },
  57: { singleNT: 1148, singleT: 1320, coupleNT: 2296, coupleT: 2640, familyNT: 2696, familyT: 3100 },
  58: { singleNT: 1182, singleT: 1359, coupleNT: 2364, coupleT: 2719, familyNT: 2764, familyT: 3179 },
  59: { singleNT: 1216, singleT: 1398, coupleNT: 2432, coupleT: 2797, familyNT: 2832, familyT: 3257 },
  60: { singleNT: 1250, singleT: 1438, coupleNT: 2500, coupleT: 2875, familyNT: 2900, familyT: 3335 },
  61: { singleNT: 1282, singleT: 1474, coupleNT: 2564, coupleT: 2949, familyNT: 2964, familyT: 3409 },
  62: { singleNT: 1315, singleT: 1512, coupleNT: 2630, coupleT: 3024, familyNT: 3030, familyT: 3484 },
  63: { singleNT: 1348, singleT: 1550, coupleNT: 2696, coupleT: 3100, familyNT: 3096, familyT: 3560 },
  64: { singleNT: 1380, singleT: 1587, coupleNT: 2760, coupleT: 3174, familyNT: 3160, familyT: 3634 }
};

export const RATE_MATRIX = {
  18: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  19: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  20: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  21: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  22: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  23: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  24: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  25: { silver: 165, aca: 415, monthlySavings: 250, annualSavings: 3000, savingsPct: 60 },
  26: { silver: 175, aca: 438, monthlySavings: 263, annualSavings: 3156, savingsPct: 60 },
  27: { silver: 184, aca: 461, monthlySavings: 277, annualSavings: 3324, savingsPct: 60 },
  28: { silver: 194, aca: 484, monthlySavings: 290, annualSavings: 3480, savingsPct: 60 },
  29: { silver: 204, aca: 507, monthlySavings: 303, annualSavings: 3636, savingsPct: 60 },
  30: { silver: 213, aca: 530, monthlySavings: 317, annualSavings: 3804, savingsPct: 60 },
  31: { silver: 223, aca: 544, monthlySavings: 321, annualSavings: 3852, savingsPct: 59 },
  32: { silver: 232, aca: 558, monthlySavings: 326, annualSavings: 3912, savingsPct: 58 },
  33: { silver: 242, aca: 572, monthlySavings: 330, annualSavings: 3960, savingsPct: 58 },
  34: { silver: 252, aca: 586, monthlySavings: 334, annualSavings: 4008, savingsPct: 57 },
  35: { silver: 261, aca: 600, monthlySavings: 339, annualSavings: 4068, savingsPct: 56 },
  36: { silver: 271, aca: 610, monthlySavings: 339, annualSavings: 4068, savingsPct: 56 },
  37: { silver: 281, aca: 620, monthlySavings: 339, annualSavings: 4068, savingsPct: 55 },
  38: { silver: 290, aca: 630, monthlySavings: 340, annualSavings: 4080, savingsPct: 54 },
  39: { silver: 300, aca: 640, monthlySavings: 340, annualSavings: 4080, savingsPct: 53 },
  40: { silver: 309, aca: 650, monthlySavings: 341, annualSavings: 4092, savingsPct: 52 },
  41: { silver: 319, aca: 670, monthlySavings: 351, annualSavings: 4212, savingsPct: 52 },
  42: { silver: 329, aca: 690, monthlySavings: 361, annualSavings: 4332, savingsPct: 52 },
  43: { silver: 338, aca: 710, monthlySavings: 372, annualSavings: 4464, savingsPct: 52 },
  44: { silver: 348, aca: 730, monthlySavings: 382, annualSavings: 4584, savingsPct: 52 },
  45: { silver: 358, aca: 750, monthlySavings: 392, annualSavings: 4704, savingsPct: 52 },
  46: { silver: 367, aca: 780, monthlySavings: 413, annualSavings: 4956, savingsPct: 53 },
  47: { silver: 377, aca: 810, monthlySavings: 433, annualSavings: 5196, savingsPct: 53 },
  48: { silver: 386, aca: 840, monthlySavings: 454, annualSavings: 5448, savingsPct: 54 },
  49: { silver: 396, aca: 870, monthlySavings: 474, annualSavings: 5688, savingsPct: 54 },
  50: { silver: 406, aca: 900, monthlySavings: 494, annualSavings: 5928, savingsPct: 55 },
  51: { silver: 415, aca: 936, monthlySavings: 521, annualSavings: 6252, savingsPct: 56 },
  52: { silver: 425, aca: 972, monthlySavings: 547, annualSavings: 6564, savingsPct: 56 },
  53: { silver: 435, aca: 1008, monthlySavings: 573, annualSavings: 6876, savingsPct: 57 },
  54: { silver: 444, aca: 1044, monthlySavings: 600, annualSavings: 7200, savingsPct: 57 },
  55: { silver: 454, aca: 1080, monthlySavings: 626, annualSavings: 7512, savingsPct: 58 },
  56: { silver: 464, aca: 1114, monthlySavings: 650, annualSavings: 7800, savingsPct: 58 },
  57: { silver: 473, aca: 1148, monthlySavings: 675, annualSavings: 8100, savingsPct: 59 },
  58: { silver: 483, aca: 1182, monthlySavings: 699, annualSavings: 8388, savingsPct: 59 },
  59: { silver: 492, aca: 1216, monthlySavings: 724, annualSavings: 8688, savingsPct: 60 },
  60: { silver: 470, aca: 1250, monthlySavings: 780, annualSavings: 9360, savingsPct: 62 },
  61: { silver: 486, aca: 1282, monthlySavings: 796, annualSavings: 9552, savingsPct: 62 },
  62: { silver: 502, aca: 1315, monthlySavings: 813, annualSavings: 9756, savingsPct: 62 },
  63: { silver: 518, aca: 1348, monthlySavings: 830, annualSavings: 9960, savingsPct: 62 },
  64: { silver: 534, aca: 1380, monthlySavings: 846, annualSavings: 10152, savingsPct: 61 }
};

export const FAMILY_SETUP_MULTIPLIERS = {
  individual: { label: 'Individual', multiplier: 1.0, icon: '👤' },
  couple: { label: 'Couple', multiplier: 2.0, icon: '👥' },
  parent_children: { label: 'Individual + Child(ren)', multiplier: 1.65, icon: '👨‍👧' },
  family: { label: 'Family', multiplier: 2.65, icon: '👨‍👩‍👧‍👦' }
};

export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
];

export const calculatePlanQuotes = ({ age = 35, familySetup = 'individual', tobacco = 'no', childrenCount = 0 }) => {
  const safeAge = Math.min(Math.max(parseInt(age, 10) || 35, 18), 64);
  const isTobacco = tobacco === 'yes';
  const numChildren = parseInt(childrenCount, 10) || 0;

  // Extra children after the 3rd child: $50/mo per extra child for IE, $100/mo for Marketplace
  const hasChildren = familySetup === 'parent_children' || familySetup === 'family';
  const extraChildren = hasChildren && numChildren > 3 ? numChildren - 3 : 0;
  const ieChildSurcharge = extraChildren * 50;
  const acaChildSurcharge = extraChildren * 100;

  let quoteGoldPlan = null;
  let quoteSilverPlan = null;

  // Exact Quote Form Lookup Logic from quotes.json
  quotes.forEach((plan) => {
    ['GOLD PLAN', 'SILVER PLAN'].forEach((planType) => {
      if (plan[planType]) {
        plan[planType].forEach((item) => {
          if (item.AGE === safeAge) {
            let price = null;
            if (familySetup === 'individual') {
              price = isTobacco ? item['Single T'] : item['Single NT'];
            } else if (familySetup === 'couple') {
              price = isTobacco ? item['Couple T'] : item['Couple NT'];
            } else if (familySetup === 'parent_children' || familySetup === 'family') {
              price = isTobacco ? item['Family T'] : item['Family NT'];
            }

            if (planType === 'GOLD PLAN') quoteGoldPlan = price;
            if (planType === 'SILVER PLAN') quoteSilverPlan = price;
          }
        });
      }
    });
  });

  // Exact ACA Benchmark lookup from official table
  const ageAca = ACA_BENCHMARK_TABLE[safeAge] || ACA_BENCHMARK_TABLE[35];
  let baseAca = 0;

  if (familySetup === 'individual') {
    baseAca = isTobacco ? ageAca.singleT : ageAca.singleNT;
  } else if (familySetup === 'couple') {
    baseAca = isTobacco ? ageAca.coupleT : ageAca.coupleNT;
  } else if (familySetup === 'parent_children' || familySetup === 'family') {
    baseAca = isTobacco ? ageAca.familyT : ageAca.familyNT;
  }

  const acaMarketplace = baseAca + acaChildSurcharge;

  const silverRate = (quoteSilverPlan !== null 
    ? quoteSilverPlan 
    : (isTobacco ? ageAca.singleT : ageAca.singleNT)) + ieChildSurcharge;

  const goldRate = (quoteGoldPlan !== null 
    ? quoteGoldPlan 
    : Math.round(silverRate * 1.5)) + ieChildSurcharge;

  const monthlySavings = Math.max(0, acaMarketplace - silverRate);
  const annualSavings = monthlySavings * 12;
  const savingsPct = acaMarketplace > 0 ? Math.round((monthlySavings / acaMarketplace) * 100) : 0;

  return {
    age: safeAge,
    silverRate,
    goldRate,
    acaMarketplace,
    monthlySavings,
    annualSavings,
    savingsPct,
    childrenCount: numChildren,
    extraChildren,
    ieChildSurcharge,
    acaChildSurcharge
  };
};

